import { render, staticRenderFns } from "./User-stations.vue?vue&type=template&id=4880840f"
import script from "./User-stations.vue?vue&type=script&lang=js"
export * from "./User-stations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports